import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'sonner';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from './contexts/AuthContext';
import { SEOProvider } from './contexts/SEOContext';
import { SiteProvider } from './contexts/SiteContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import AdSlot from './components/AdSlot';
import { GlobalSchema } from './components/SEO';
import ScrollToTop from './components/ScrollToTop';
import PwaPrompt from './components/PwaPrompt';
import HomePage from './pages/HomePage';
import AuthPage from './pages/AuthPage';
import ForumPage from './pages/ForumPage';
import ForumCategoryPage from './pages/ForumCategoryPage';
import TopicDetailPage from './pages/TopicDetailPage';
import CatalogPage from './pages/CatalogPage';
import VehicleDetailPage from './pages/VehicleDetailPage';
import SitePage from './pages/SitePage';
import EventsPage from './pages/EventsPage';
import UserProfilePage from './pages/UserProfilePage';
import GaragePage from './pages/GaragePage';
import BadgesPage from './pages/BadgesPage';
import AdminPage from './pages/AdminPage';
import NewsPage from './pages/NewsPage';
import UsersPage from './pages/UsersPage';
import MessagesPage from './pages/MessagesPage';
import NotFoundPage from './pages/NotFoundPage';
import './App.css';

function App() {
  const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';
  return (
    <HelmetProvider>
      <GoogleOAuthProvider clientId={googleClientId}>
        <AuthProvider>
        <SEOProvider>
          <SiteProvider>
            <BrowserRouter>
              <ScrollToTop />
              <GlobalSchema />
              <div className="min-h-screen bg-slate-50 flex flex-col">
                <Navbar />
                <div className="max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8 mt-3">
                  <AdSlot placement="global_header" className="mb-2" />
                </div>
                <main className="flex-1">
                  <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/giris" element={<AuthPage mode="login" />} />
                    <Route path="/kayit" element={<AuthPage mode="register" />} />
                    <Route path="/forum" element={<ForumPage />} />
                    <Route path="/forum/kategori/:categorySlug" element={<ForumCategoryPage />} />
                    <Route path="/forum/konu/:topicId" element={<TopicDetailPage />} />
                    <Route path="/katalog" element={<Navigate to="/araclar" replace />} />
                    <Route path="/araclar" element={<CatalogPage />} />
                    <Route path="/arac/:vehicleId" element={<VehicleDetailPage />} />
                    <Route path="/etkinlikler" element={<EventsPage />} />
                    <Route path="/haberler" element={<NewsPage />} />
                    <Route path="/kullanicilar" element={<UsersPage />} />
                    <Route path="/profil/:userId" element={<UserProfilePage />} />
                    <Route path="/garaj" element={<GaragePage />} />
                    <Route path="/mesajlar" element={<MessagesPage />} />
                    <Route path="/mesajlar/:convId" element={<MessagesPage />} />
                    <Route path="/rozetler" element={<BadgesPage />} />
                    <Route path="/sayfa/:slug" element={<SitePage />} />
                    <Route path="/admin" element={<AdminPage />} />
                    <Route path="*" element={<NotFoundPage />} />
                  </Routes>
                </main>
                <div className="max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8 mt-6">
                  <AdSlot placement="global_footer" />
                </div>
                <Footer />
              </div>
              <PwaPrompt />
              <Toaster position="top-right" richColors />
            </BrowserRouter>
          </SiteProvider>
        </SEOProvider>
      </AuthProvider>
      </GoogleOAuthProvider>
    </HelmetProvider>
  );
}

export default App;
